import { MutableRefObject, useEffect, useRef, useState } from "react"

export function RowsAndColumns(props:{rows:number, columns:number, onUpdate:Function}){
    const [rows, setRows] = useState(props.rows)
    const [columns, setColumns] = useState(props.columns)
    const propRows:MutableRefObject<number> = useRef(props.rows)
    const propColumns:MutableRefObject<number> = useRef(props.rows)
    const updateRows = (e:any) =>{
        if(!isNaN(e.target.value) && Number(e.target.value) > 0){
            setRows(Number(e.target.value))
        }
    }
    const updateColumns = (e:any) =>{
        if(!isNaN(e.target.value) && Number(e.target.value) > 0){
            setColumns(Number(e.target.value))
        }
    }
    const onApply = () => {
        props.onUpdate(rows, columns)
    }
    useEffect(()=>{
        if(propRows.current != props.rows){setRows(props.rows); propRows.current = props.rows}
        if(propColumns.current != props.columns){setColumns(props.columns); propColumns.current = props.columns}
    })
    return(
        <div className={'rows-columns-controls'}>
            Rows: <input type='text' value={rows} onChange={updateRows}/> Columns: <input type='text' value={columns} onChange={updateColumns}/>
            <button type='button' onClick={onApply}>Apply</button>
        </div>
    )
}